module.exports = __webpack_public_path__ + "static/about-us-who-we-are-hero-7930e8c97ada7aa71aac7ff7c4aa440e.jpg";